import { useQuery } from '@tanstack/react-query';
import type { PricingData } from '../services/pricing.service';
import { usePricingService } from '../services/pricing.service';

/**
 * Hook for using pricing data in components
 * @param countryCode ISO country code (e.g., 'DE', 'US')
 * @returns Object with pricing data and loading state
 */
export const usePricing = (countryCode: string = 'DE') => {
    const pricingService = usePricingService();

    const pricingQuery = useQuery<PricingData>({
        queryKey: ['pricing', countryCode],
        queryFn: () => pricingService.getPricingData(countryCode),
        staleTime: 1000 * 60 * 60, // 1 hour
    });

    return {
        pricing: pricingQuery.data,
        isLoading: pricingQuery.isLoading,
        error: pricingQuery.error,
        refetch: pricingQuery.refetch,
    };
};
